import { type BlokProps, StoryblokComponent } from "@trydig/storyblok";
import { clsx } from "@trydig/ui";
import { BlokWrap } from "~/components/bloks/BlokWrap";
import type { CardGridStoryblok } from "~/generated/sb/blok-types";
import styles from "./CardGridBlok.module.css";

export const CardGridBlok = ({ blok, preview }: BlokProps<CardGridStoryblok>) => {
	return (
		<BlokWrap
			as="div"
			editable={blok}
			className={clsx(styles.root, "card-grid")}
			style={{ gridTemplateColumns: `repeat(${blok.cards.length},1fr)` }}
			data-layout="blok"
		>
			{blok.cards.map((card) => {
				return (
					<div key={card._uid} className={styles.card} data-layout="blok">
						<StoryblokComponent blok={card} preview={preview} />
					</div>
				);
			})}
		</BlokWrap>
	);
};
